import React from "react";
import { useController, useFormContext } from "react-hook-form";
import { ColorPickerField } from "../fields/ColorPickerField";

interface Props
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label?: string;
  helperText?: string;
  labelIcon?: React.ReactNode;
  name: string;
}

export const ColorPickerInput = ({ name, ...rest }: Props) => {
  const { control, getFieldState, formState } = useFormContext();

  const {
    field: { onChange, value, ref },
  } = useController({
    name,
    control,
  });

  return (
    <ColorPickerField
      onChange={onChange}
      value={value}
      innerRef={ref}
      errorMessage={getFieldState(name, formState).error?.message}
      {...rest}
    />
  );
};
